import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManabuaFeaturedArticles',
  setup(__props) {

const isProd = process.env.VUE_APP_ENVIRONMENT === 'production';
const collectionId = isProd ? 'BHxFzzKCurfkKAaQ_Q1ii' : 'Kaj2R9t_eX6FmYmWA-TVH';

onMounted(() => {
  window.location.href = `/collections/${collectionId}/edit`;
});

return { __sfc: true,isProd, collectionId }
}

})